import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDfnD4Dniryn4Qu6JljDPUa8gdFWNSmqe8",
    authDomain: "airebroker-8a233.firebaseapp.com",
    projectId: "airebroker-8a233",
    storageBucket: "airebroker-8a233.firebasestorage.app",
    messagingSenderId: "695425132839",
    appId: "1:695425132839:web:87b9428fabec5a5715e102",
    measurementId: "G-KLK49YMXJH",
};
let auth;
try {
    const app = initializeApp(firebaseConfig);

    auth = getAuth(app);
} catch (error) {
    console.log("error...............", error);
}

export { auth };
